import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { MerchantsComponent } from './merchants.component';
import { AccessGuard } from '@app/@shared/guards/access.guard';
import { AccessType } from '@app/@shared/enums/access-types.enum';
import { NewMerchantComponent } from '@app/areas/merchants/components/new-merchant/new-merchant.component';
import { MerchantDetailComponent } from '@app/areas/merchants/components/merchant-detail/merchant-detail.component';
import { MerchantNoAccessComponent } from '@app/areas/merchants/components/merchant-no-access/merchant-no-access.component';
import { MerchantAccessGuard } from '@app/areas/merchants/guards/merchant-access.guard';
import { LocationTableComponent } from '@app/areas/merchants/components/location-table/location-table.component';
import { NewLocationComponent } from '@app/areas/merchants/components/new-location/new-location.component';
import { LocationDetailComponent } from '@app/areas/merchants/components/location-detail/location-detail.component';
import { EmployeeTableComponent } from '@app/areas/merchants/components/employee-table/employee-table.component';
import { NewEmployeeComponent } from '@app/areas/merchants/components/new-employee/new-employee.component';
import { EmployeeDetailComponent } from '@app/areas/merchants/components/employee-detail/employee-detail.component';
import { MerchantOverviewComponent } from '@app/areas/merchants/components/merchant-overview/merchant-overview.component';
import { DeviceTableComponent } from '@app/areas/merchants/components/device-table/device-table.component';
import { NewDeviceComponent } from '@app/areas/merchants/components/new-device/new-device.component';
import { DeviceDetailComponent } from '@app/areas/merchants/components/device-detail/device-detail.component';
import { AccessTableComponent } from '@app/areas/merchants/components/access-table/access-table.component';
import { OrderTableComponent } from '@app/areas/merchants/components/order-table/order-table.component';
import { RepresentativeDetailComponent } from '@app/areas/admin/representatives/components/representative-detail/representative-detail.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: ':coalitionId/merchants',
      component: MerchantsComponent,
      canActivate: [AccessGuard],
      data: { title: 'Merchants', requiredAccessTypes: [AccessType.MerchantAdmin] },
    },
    {
      path: ':coalitionId/merchants/new',
      component: NewMerchantComponent,
      canActivate: [AccessGuard],
      data: { title: 'New Merchant', requiredAccessTypes: [AccessType.MerchantAdmin] },
    },
    {
      path: ':coalitionId/merchants/no-access/:merchantId',
      component: MerchantNoAccessComponent,
      canActivate: [AccessGuard],
      data: { title: 'Merchant', requiredAccessTypes: [AccessType.MerchantAdmin] },
    },
    {
      path: ':coalitionId/merchants/:merchantId',
      component: MerchantDetailComponent,
      canActivate: [AccessGuard, MerchantAccessGuard],
      data: { title: 'Merchant', requiredAccessTypes: [AccessType.MerchantAdmin] },
      children: [
        { path: '', pathMatch: 'full', redirectTo: 'overview' },
        { path: 'overview', component: MerchantOverviewComponent },
        {
          path: 'locations',
          children: [
            { path: '', component: LocationTableComponent },
            { path: 'new', component: NewLocationComponent },
            { path: ':locationId', component: LocationDetailComponent },
          ],
        },
        { path: 'orders', component: OrderTableComponent },
        {
          path: 'employees',
          children: [
            { path: '', component: EmployeeTableComponent },
            { path: 'new', component: NewEmployeeComponent },
            { path: ':employeeId', component: EmployeeDetailComponent },
          ],
        },
        {
          path: 'devices',
          children: [
            { path: '', component: DeviceTableComponent },
            { path: 'new', component: NewDeviceComponent },
            { path: ':deviceId', component: DeviceDetailComponent },
          ],
        },
        {
          path: 'access',
          children: [
            { path: '', component: AccessTableComponent },
            {
              path: ':representativeId',
              component: RepresentativeDetailComponent,
              canActivate: [AccessGuard],
              data: { title: 'Representative', requiredAccessTypes: [AccessType.RepresentativeAdmin] },
            },
          ],
        },
      ],
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MerchantsRoutingModule {}
